<template>
    <div class="mobile-navigation d-lg-none" :class="{ 'open': isMobileNavigationOpen }">
        <div class="top-area" v-show="isNavigationInitialized">
            <ul class="breadcrumb d-block px-3 py-0">
                <li class="btn-close" @click="closeNavigation()"></li>
            </ul>
            <ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">
                <li class="ddown" v-for="(category, index) in dataContainer1.categories" v-if="index >= 1">
                    <template v-if="category.childrenNav && category.childrenNav.length">
                        <div @click="slideTo(category)">{{ category.title }}
                            <i class="fa fa-lg fa-angle-right" aria-hidden="true"></i>
                        </div>
                    </template>
                    <template v-else>
                        <a :href="category.url">{{ category.title }}</a>
                    </template>
                </li>
            </ul>

            <ul v-menu id="menu-2" class="mainmenu w-100 p-0 m-0">
                <li class="ddown nav-back" v-if="dataContainer2.parent" >
                    <span class="nav-direction btn-up" @click="slideTo(dataContainer2.parent || null, true)">
                        <i class="fa fa-lg fa-angle-left" aria-hidden="true"></i>
                    </span>
                    <a :href="dataContainer2.parent.url">{{ dataContainer2.parent.title }}</a>
                </li>

                <li  class="ddown" v-for="category in dataContainer2.categories">
                    <a :href="category.url">{{ category.title }}</a>
                </li>
            </ul>
        </div>

        <template v-if="!isNavigationInitialized">
            <ul class="breadcrumb">
                <li class="btn-close" @click="closeNavigation()"></li>

                <li class="breadcrumb-item">
                    <i class="fa fa-home" aria-hidden="true"></i>
                </li>
            </ul>

            <loading-animation></loading-animation>
        </template>

        <div class="middle-area">
            <a class="link-ext" :href="bCatLink">{{bText}}</a>
            <a class="btn-settings" data-toggle="modal" data-target="#shopSettingsWrapper" aria-expanded="false" aria-controls="shopSettingsWrapper" :aria-label="$translate('Ceres::Template.headerCountry') + ' ' + $translate('Ceres::Template.headerCurrency')">
				<i :class="lang"></i>
				<span>{{ currency }}</span>
			</a>
        </div>
        <div class="nav-info bottom-area">
            <div v-for="iText in infoText">{{ iText }}</div>
        </div>
    </div>
</template>

<script>
import { MediaQueryHelper } from "../../helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "../../helper/utils";
import Vue from "vue";
import { mapState } from "vuex";

export default {

    props: {
        template: {
            default: "#vue-mobile-navigation",
            type: String
        },
        initialCategory: Object,
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md"]
        },
        bText: {
            type: String,
            default: ""
        },
        bCatLink: {
            type: String,
            default: ""
        }
    },
    jsonDataFields: [
        "navSettingsB",
        "infoText"
    ],
    data()
    {
        return {
            dataContainer1: {
                categories: []
            },
            dataContainer2: {
                parent: {},
                categories: []
            },
            isNavigationInitialized: false
        };
    },

    computed:
    {
        currency() {
            return "" + App.activeCurrency;
        },
        lang() {
            return "flag-icon flag-icon-"+App.language;
        },
        ...mapState({
            isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
        })
    },

    mounted()
    {
        this.addEventListener();
    },

    methods:
    {
        addEventListener()
        {
            const QueryHelper = new MediaQueryHelper();
            const breakpoint = QueryHelper.getCurrentBreakpoint();

            QueryHelper.addFunction(this.initNavigation, this.breakpoints);

            if (this.breakpoints.includes(breakpoint))
            {
                this.initNavigation();
            }
        },

        initNavigation()
        {
            this.dataContainer1.categories = this.navSettingsB;
            this.isNavigationInitialized = true;
        },

        slideTo(category, back)
        {

            if (back)
            {
                this.dataContainer1.categories = this.navSettingsB || [];

                $("#menu-2").trigger("menu-deactivated", { back: !!back });
                $("#menu-1").trigger("menu-activated", { back: !!back });
            }
            else
            {
                this.dataContainer2.parent = category;
                this.dataContainer2.categories = category.childrenNav || [];

                $("#menu-1").trigger("menu-deactivated", { back: !!back });
                $("#menu-2").trigger("menu-activated", { back: !!back });
            }

        },

        closeNavigation()
        {
            this.$store.commit("setIsMobileNavigationOpen", false);
        }

    },

    directives:
    {
        menu: {
            bind(el)
            {
                // add "activated" classes when menu is activated
                $(el).on("menu-activated", (event, params) =>
                {
                    $(event.target).addClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
                });
                // add "deactivated" classes when menu is deactivated
                $(el).on("menu-deactivated", (event, params) =>
                {
                    $(event.target).removeClass("menu-active");
                    $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
                });
                // this removes the animation class automatically after the animation has completed
                $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () =>
                {
                    $(".mainmenu").removeClass((index, className) =>
                    {
                        return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
                    });
                });
            }
        }
    }
}
</script>
